import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { appConfig } from '../shared/config/app-config'

let initialized = false

export function initializeTelemetry() {
  if (initialized || import.meta.env.MODE === 'test' || !appConfig.telemetryEnabled) {
    return
  }
  const provider = new WebTracerProvider()
  provider.register()
  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [/^\/api\//],
        clearTimingResources: true,
      }),
    ],
  })
  initialized = true
}
